import type { EventResponse, Market, Outcome } from '@/types';

import { TRADE_SIDES } from '@/constants';

interface UseMarketBuyHandlersProps {
  event: EventResponse | undefined;
  isMobile: boolean;
  setSelectedOutcomeId: (id: string | null) => void;
  setSelectedSide: (side: 'yes' | 'no') => void;
  handleOpenTradeModal: (market: Market, outcome: Outcome, isBuyOrder: boolean) => void;
  activeTab?: 'buy' | 'sell';
}

export const useMarketBuyHandlers = ({
  event,
  isMobile,
  setSelectedOutcomeId,
  setSelectedSide,
  handleOpenTradeModal,
  activeTab = 'buy',
}: UseMarketBuyHandlersProps) => {
  const isBuyOrder = activeTab === 'buy';
  const handleBuyYesClick = (outcomeId: string) => () => {
    if (!event?.markets) return;
    const foundMarket = event.markets.find(
      (m) => Array.isArray(m.outcomes) && (m.outcomes as any[]).some((o) => o?.id === outcomeId)
    );
    const foundOutcome = (foundMarket?.outcomes as any[])?.find((o) => o?.id === outcomeId);

    if (foundOutcome && foundMarket) {
      if (!isMobile) {
        setSelectedOutcomeId(outcomeId);
        setSelectedSide(TRADE_SIDES.YES);
      } else {
        handleOpenTradeModal(foundMarket as any, foundOutcome as any, isBuyOrder);
      }
    }
  };

  const handleBuyNoClick = (outcomeId: string) => () => {
    if (!event?.markets) return;

    let foundOutcome: Outcome | undefined;
    let foundMarket: Market | undefined;

    for (const m of event.markets) {
      if (Array.isArray(m.outcomes)) {
        const hasOutcome = m.outcomes.some((o) => o.id === outcomeId);
        if (hasOutcome) {
          const outcome = m.outcomes.find((o, idx) => o?.name?.toLowerCase() === 'no' || idx === 1);
          if (outcome) {
            foundOutcome = outcome as unknown as Outcome;
            foundMarket = m as unknown as Market;
            break;
          }
        }
      }
    }

    if (foundOutcome && foundMarket) {
      if (!isMobile) {
        setSelectedOutcomeId(outcomeId);
        setSelectedSide(TRADE_SIDES.NO);
      } else {
        handleOpenTradeModal(foundMarket as any, foundOutcome as any, isBuyOrder);
      }
    }
  };

  return {
    handleBuyYesClick,
    handleBuyNoClick,
  };
};
